import { Table, Tag } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

const columns = [
  {
    title: "Thumbnail",
    key: "image",
    // A just-uploaded thumbnail's display copy can lag behind the upload.
    render: (collection: { thumbnail: string | null; displayThumbnail: string | null }) => (
      <img
        style={{ width: 75 }}
        src={collection.displayThumbnail ?? collection.thumbnail ?? undefined}
        loading="lazy"
        onError={(e) => {
          if (collection.thumbnail && e.currentTarget.src !== collection.thumbnail) {
            e.currentTarget.src = collection.thumbnail;
          }
        }}
      />
    ),
  },
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Status",
    dataIndex: "hidden",
    key: "hidden",
    render: (hidden: boolean) =>
      hidden ? (
        <Tag color="orange">Verborgen</Tag>
      ) : (
        <Tag color="green">Zichtbaar</Tag>
      ),
  },
];

interface Props {
  brickCollections: any[] | null;
}

const OrganizationBrickCollections: React.FC<Props> = ({ brickCollections }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Table
      loading={brickCollections == null}
      columns={columns}
      dataSource={brickCollections ?? undefined}
      onRow={(record) => {
        return {
          onClick: () =>
            navigate(
              `${location.pathname}/collections/${record._id}`
            ),
        };
      }}
    />
  );
};

export default OrganizationBrickCollections;
